<template>
	<div class="csv">
		<p class="csv__notice">
			다운로드 파일 포맷은 CSV이며, 1회 최대 {{ limit | currency }}개 까지
			다운로드 가능
		</p>
		<p class="csv__notice">
			제품 등록순 기준 다운로드시 약 5~10초 정도 소요되며, 데이터량에 따라
			변동될 수 있습니다.
		</p>
		<ul class="csv__list">
			<li
				v-for="item in getDownOptionList"
				:key="item.id"
				class="csv__list__item"
			>
				<p class="csv__list__item__name">no. {{ item.value }}</p>
				<button
					class="btn csv__list__item__btn"
					type="button"
					@click="download(item.id, item.value)"
				>
					Download
				</button>
			</li>
		</ul>
	</div>
</template>
<script>
	import { mapState } from 'vuex';

	export default {
		name: 'ExcelDownList',
		data() {
			return {
				limit: 10000,
				totalItem: 0,
				type: '',
			};
		},
		computed: {
			...mapState('modal', {
				modalParams: state => state.params,
			}),
			getDownOptionList() {
				const total = this.totalItem;
				const limit = this.limit;
				const cnt = Math.ceil(total / limit);
				return new Array(cnt).fill({}).map((_, idx) => ({
					id: idx * limit,
					value:
						idx + 1 === cnt
							? `${idx * limit + 1} - ${total}`
							: `${idx * limit + 1} - ${(idx + 1) * limit}`,
				}));
			},
		},
		created() {
			this.totalItem = this.modalParams.total;
			this.type = this.modalParams.type;
		},
		methods: {
			download(offset, period) {
				const params = {
					...this.modalParams.params,
					limit: this.limit,
					offset,
				};
				switch (this.type) {
					case 'productList':
						this.$store.dispatch('productList/downExcel', params);
						break;
					case 'register':
						this.$store.dispatch('register/downExcel', {
							...this.modalParams.params,
							...params,
						});
						break;
					case 'reviewList':
						this.modalParams.clickCb(params, period);
						break;
					case 'csList':
						this.modalParams.clickCb(
							{
								...this.modalParams.params,
								size: this.limit,
								page: offset / this.limit + 1,
							},
							period
						);
						break;
					case 'brandList':
						this.$store.dispatch('brandList/downExcel', {
							params,
							totalItem: this.totalItem,
						});
						break;
					case 'qnaQList':
						this.modalParams.clickCb(offset);
						break;
				}
			},
		},
	};
</script>
<style lang="scss" scoped>
	.csv {
		height: 100%;
		position: relative;
		padding-top: 52px;
	}

	.csv__notice {
		position: absolute;
		display: block;
		height: 14px;
		color: $btn-blue;
		font-size: 1rem;
		font-weight: 700;
		top: 12px;
		left: 0;

		&:nth-child(2) {
			top: 40px;
		}
	}

	.csv__list {
		overflow: auto;
		height: 100%;
		margin: 18px 0 0 0;
		border-top: solid 1px #ebebed;
		border-bottom: solid 1px #ebebed;
	}

	.csv__list__item {
		padding: 10px;

		&:after {
			content: '';
			display: block;
			clear: both;
		}

		&:hover {
			background: #f4f7fa;
		}
	}

	.csv__list__item__name {
		float: left;
		display: block;
		line-height: 30px;
	}

	.csv__list__item__btn {
		float: right;
		display: block;
	}
</style>
